// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3OIHQ","footer":"ReportModalFilter_footer__3l9xF"};